import { HashRouter as Router } from 'react-router-dom';

import { StyleWrapper } from './styleWrapper';
import { CssVariables } from './globalStyle';
import { BrandWrapper } from './brandWrapper';
import { HelmetProvider } from 'react-helmet-async';
import { ScrollRestoration } from '../../routes/parts/scrollRestoration';

// global font-awesome icon style overrides
import './icons.css';
// global css variables
import './variables.css';

export const App = () => (
  <HelmetProvider>
    <Router>
      <ScrollRestoration>
        <BrandWrapper>
          <CssVariables />
          <StyleWrapper />
        </BrandWrapper>
      </ScrollRestoration>
    </Router>
  </HelmetProvider>
);
